<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "App",
  data() {
    return {
      fullHeight: document.documentElement.clientHeight,
      fullWidth: document.documentElement.clientWidth,
    };
  },
  methods: {
    ...mapMutations("app", ["setWindowData"]),
    onresize() {
      window.fullHeight = document.documentElement.clientHeight;
      this.fullHeight = window.fullHeight;
      window.fullWidth = document.documentElement.clientWidth;
      this.fullWidth = window.fullWidth;
      this.setWindowData({
        fullHeight: this.fullHeight,
        fullWidth: this.fullWidth,
      });
    },
  },
  created() {
    // // 进入前清理一下 缓存
    // UserPersistence.clear();

    // let token = this.$GetUrl.getUrlSearch('token');

    // if (!token || token === 'null') {

    //   return
    // }
    // UserPersistence.saveToken(token);
    this.$nextTick(() => {
      if (window.self !== window.top) {
        parent.postMessage(
          {
            type: "load",
          },
          "*"
        );
      }
    });
    /** 考试离考监听 */
    window.addEventListener("focus", () => {
      try {
        parent.postMessage({ type: "focus" }, "*");
        parent.parent.postMessage({ type: "focus" }, "*");
      } catch (error) {
        console.log(error);
      }
    });
    window.addEventListener("blur", () => {
      try {
        parent.postMessage({ type: "blur" }, "*");
      } catch (error) {
        console.log(error);
      }
    });
    if (window.self !== window.top) {
      parent.postMessage(
        {
          type: "load",
        },
        "*"
      );
    }
    /** 考试离考监听 */
    // window.addEventListener("focus", () => {
    //   try {
    //     // console.log('----excel--获取焦点----');
    //     parent.postMessage({ type: "focus" }, "*");
    //     parent.parent.postMessage({ type: "focus" }, "*");
    //   } catch (error) {
    //     console.log(error);
    //   }
    // });
    // window.addEventListener("blur", () => {
    //   try {
    //     // console.log('----excel--失焦----');
    //     parent.postMessage({ type: "blur" }, "*");
    //   } catch (error) {
    //     console.log(error);
    //   }
    // });
  },
  mounted() {
    window.addEventListener("resize", this.onresize);
    this.setWindowData({
      fullHeight: this.fullHeight,
      fullWidth: this.fullWidth,
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onresize);
  },
};
</script>
<style lang="scss">
@import "styles/reset";
@import "styles/base";
</style>
<style>
* {
  margin: 0;
  padding: 0;
}

html,
body {
  width: 100%;
  height: 100%;
  padding: 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  height: 100%;
  margin: 0;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue